<script setup lang="ts">
import IntroText from '../components/IntroText.vue';
import ClaimForm from '../components/ClaimForm.vue';
import HelpText from '../components/HelpText.vue';
import HelpBanner from '../components/HelpBanner.vue';
</script>

<template>
  <main>
    <div class="wrapper">
      <h1>Claim Avios and Tier Credits</h1>
    </div>
    <IntroText />
    <HelpBanner />
    <ClaimForm />
    <HelpText />
  </main>
</template>
